import { toFeatureState } from '@etrigan/feature-toggles-client'
import {
    isfeatureToggleAction,
    TogglesReduxState,
} from '../feature-togglings/reducer'
import { Features } from '../features'
import { Middleware } from '../store'

export function configureTrackJs(version: string) {
    if (typeof window === 'object' && (window as any).trackJs) {
        trackJs.configure({ version })
    }
}

export function updateTrackJsSectionMetadata(section: string) {
    if (typeof window === 'object' && (window as any).trackJs) {
        trackJs.addMetadata(`section`, section)
    }
}

export function updateTrackJsFeatureMetadata(toggleState: TogglesReduxState) {
    if (typeof window === 'object' && (window as any).trackJs) {
        const featureState = toFeatureState(toggleState)
        for (const featureName in featureState) {
            if (featureState.hasOwnProperty(featureName)) {
                const feature = featureState[featureName as Features]
                if (typeof feature === 'object') {
                    trackJs.addMetadata(
                        `feature_${featureName}`,
                        feature.value.raw,
                    )
                }
            }
        }
    }
}

export function logInTrackJS(error: string | Error) {
    if (typeof window === 'object' && (window as any).trackJs) {
        trackJs.track(error)
    }
}

export function getTrackJSMiddleware() {
    const trackJSMiddleware: Middleware = (api) => (next) => (action) => {
        const dispatch = next(action)
        if (isfeatureToggleAction(action)) {
            updateTrackJsFeatureMetadata(api.getState().toggles)
        }
        return dispatch
    }
    return trackJSMiddleware
}
